module.exports = __webpack_public_path__ + "img/inst-modal-4.875854cd.png";